export default __webpack_public_path__ + "static/tablet_sek2_KV06-ce48d85a4d9a451cf6b9dbcb673b494b.mp4";